export const MARKING_FORM_DATA_VEHICLE = "Formulario Datos Vehículo";
export const MARKING_FORM_DATA_PERSON = "Formulario Datos Personales";
export const MARKING_PERSONAL_DATA = "Datos Personales";
export const MARKING_MOTOR_SERIE =
    "Formulario Datos Adicionales (Motor y Serie)";

export const MARKING_INTERECTIONS = "Interacciones";

// ========== Labels ================== //
export const MARKING_LABEL_EDIT_VEHICLE = "Editar datos del vehículo";
export const MARKING_LABEL_EDIT_ADDRES = "Editar datos del domicilio";
export const MARKING_LABEL_EDIT_PERSON = "Editar datos del personales";
// ========== Channels ================ //
export const MARKING_VEHICLE_INSURANCE = "";

// ========== events actions ============ //
export const MARKING_EVENT_TRACK_FORM_SUBMIT = "trackFormSubmit";
export const MARKING_EVENT_TRACK_SNAPSHOT = "trackSnapshot";
export const MARKING_EVENT_TRACK_VIRTUAL = "trackVirtual";
export const MARKING_EVENT_TRACK_FORM_VIEW = "trackFormView";
export const MARKING_EVENT_TRACK_METADATA = "trackMetadata";
export const MARKING_EVENT_TRACK_ACTION = "trackAction";
export const MARKING_EVENT_TRACK_LOG = "trackLog";
export const MARKING_EVENT_TRACK_ERROR = "trackError";

// ========== listener action ========== //
export const MARKING_ACTION_CLICK = "click";
